import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { DatePickerDropdown } from "@xo-union/tk-component-datepicker";
import Field from "../Field/index.js";
const DatePickerField = _ref => {
  let {
    id,
    name,
    subText,
    state,
    label,
    validations,
    onChange,
    classes,
    subTextOnInvalid,
    subTextOnValid,
    disabled,
    disabledDates,
    value,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(DatePickerDropdown, _extends({}, props, {
    value: value,
    onChange: onChange,
    block: true,
    disabled: disabledDates,
    renderInput: inputProps => /*#__PURE__*/React.createElement(Field, _extends({
      id: id,
      name: name,
      subText: subText,
      state: state,
      label: label,
      classes: classes,
      validations: validations,
      subTextOnInvalid: subTextOnInvalid,
      subTextOnValid: subTextOnValid,
      disabled: disabled
    }, inputProps))
  }));
};
export default DatePickerField;